import { defineMessages } from "react-intl"

export const dealershipListMessages = defineMessages({
	chooseLanguage: {
		defaultMessage: "Choose Language",
		id: "dealerList.menu.chooseLanguage",
	},
	country: {
		defaultMessage: "Country",
		id: "dealerList.header.country",
	},
	dealerKey: {
		defaultMessage: "Partner No.",
		id: "dealerList.header.partnerNumber",
	},
	name: {
		defaultMessage: "Name",
		id: "dealerList.header.name",
	},
	noResultsHeadline: {
		defaultMessage: "0 Dealer found.",
		id: "dealerList.noResults.headline",
	},
	organizationType: {
		defaultMessage: "PPN Organization Type",
		id: "dealerList.header.organizationType",
	},
	totalCount: {
		defaultMessage: "{count, plural, one {# Organization} other {# Organizations}}",
		id: "dealerList.totalCount",
	},
})
